/*---------------------------
| Action Types (TOC)
---------------------------*/
export const actionTypes = {
    ASDL_SET_IS_READY_FOR_DOWNLOAD: "ASDL: setIsReadyForDownload",
    ASDL_SET_ATTRIBUTION_REQUIRED: "ASDL: setAttributionRequired",
    ASDL_SET_ATTRIBUTION_IS_VISIBLE: "ASDL: setAttributionIsVisible",
    ASDL_SET_ATTRIBUTION_COPIED: "ASDL: setAttributionCopied",
    ASDL_SET_SHOW_PUR_TYPE_DRAWER: "ASDL: setShowPurchaseTypeDrawer",
    ASDL_SET_SHOW_SPEECH_BUBBLE: "ASDL: setShowSpeechBubble",
    ASDL_SET_PURCHASE_TYPE: "ASDL: setPurchaseType",
    ASDL_SET_DOWNLOAD_RESOURCE_PARAMS: "ASDL: setDownloadResourceParams" // may be exposed to host as Photo and Icon differ
};
